enum WorkbenchTypes {
  Operations = "Operations",
  Activities = "Activities",
}

export default WorkbenchTypes
